import {initializeApp} from 'firebase/app';
import {getStorage} from 'firebase/storage';
import {getAnalytics} from 'firebase/analytics';
import {
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from 'firebase/auth';
import {
  getFirestore,
  collection,
  addDoc,
  query,
  getDocs,
  getDoc,
  where,
  limit,
  collectionGroup,
  doc,
  orderBy,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIERBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage();
const auth = getAuth(app);
const analytics = getAnalytics(app);

// AUTH

// DATABASE
// PROFILEs
const getUniversalProfile = async uid => {
  try {
    const docRef = doc(db, 'users', uid);
    const userDoc = await getDoc(docRef);
    if (userDoc.exists()) {
      return userDoc.data();
    }
    return null;
  } catch (err) {
    throw err;
  }
};

const getClientProfile = async uid => {
  try {
    const docRef = doc(db, 'clients', uid);
    const userDoc = await getDoc(docRef);
    if (userDoc.exists()) {
      return userDoc.data();
    }
    return null;
  } catch (err) {
    throw err;
  }
};

const getFinancialProfile = async uid => {
  try {
    const docRef = doc(db, `users`, `${uid}/profile/profile`);
    const userDoc = await getDoc(docRef);
    if (userDoc.exists()) {
      return userDoc.data();
    }

    return null;
  } catch (err) {
    throw err;
  }
};

// PLAID
const getAccounts = async uid => {
  try {
    const docRef = collection(db, `users`, `${uid}/plaidAccounts`);
    const accountDocs = await getDocs(docRef);

    if (accountDocs.size) {
      return accountDocs.docs.map(doc => doc.data());
    }

    return [];
  } catch (err) {
    throw err;
  }
};

const getTransactionsBetween = async (uid, start, end) => {
  try {
    const docRef = collection(db, `users`, `${uid}/plaidTransactions`);

    const transDocs = await getDocs(
      query(
        docRef,
        where('date', '>=', start),
        where('date', '<=', end),
        orderBy('date', 'desc'),
      ),
    );

    if (transDocs.size) {
      return transDocs.docs.map(doc => doc.data());
    }

    return [];
  } catch (err) {
    throw err;
  }
};

// DASHBOARD
const getDashboardData = async (filter = null) => {
  try {
    let group;
    if (filter) {
      group = query(
        collection(db, 'dashboardData'),
        where('organizationCode', '==', filter),
      );
    } else {
      group = query(collection(db, 'dashboardData'));
    }
    const users = await getDocs(group);
    return users.docs.map(doc => doc.data());
  } catch (err) {
    throw err;
  }
};

const getAtRiskData = async (start, filter = null) => {
  try {
    let group;
    if (filter) {
      group = query(
        collectionGroup(db, 'atRisk'),
        where('date', '>=', start),
        where('organizationCode', '==', filter),
      );
    } else {
      group = query(collectionGroup(db, 'atRisk'), where('date', '>=', start));
    }
    const data = await getDocs(group);
    // TODO: check that exists first
    return data.docs.map(doc => doc.data());
  } catch (err) {
    throw err;
  }
};

export {
  db,
  storage,
  analytics,
  getUniversalProfile,
  getClientProfile,
  getFinancialProfile,
  getAccounts,
  getTransactionsBetween,
  getDashboardData,
  getAtRiskData,
};
